export default __webpack_public_path__ + "static/media/lion-cub-evil.4b9c8bc2.png";